
    import './styles.scoped.css';
    export default {
  "modal-actions": "awsui_modal-actions_12hyz_1h2lx_9",
  "submit-button": "awsui_submit-button_12hyz_1h2lx_13",
  "last-updated-caption": "awsui_last-updated-caption_12hyz_1h2lx_17"
};
  